import { rgba } from 'polished';
import { focusOutline } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

export const Option = styled.button<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;

  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};

  border-radius: ${({ theme }) => theme.spacing(3)};
  border: 1px solid transparent;
  background: ${({ theme }) => theme.palette.backgroundExtended.card};
  cursor: pointer;

  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }

  &:focus-visible {
    ${focusOutline};
  }

  ${({ $selected, theme }) =>
    $selected &&
    css`
      border-color: ${theme.palette.primary.main};
      background: ${rgba(theme.palette.primary.main, 0.08)};

      &:hover {
        background: ${rgba(theme.palette.primary.main, 0.12)};
      }
    `};
`;
